import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const ApproveFourElement = (props) => {
  return (
    <div className="signature-element reviewed">
      <div className="signed">
        <div className="signed-text">Approved</div>
      </div>
      <div>
        <b>{props.approvedThreeBy}</b> {moment(props.approvedThreeAt).format('HH:mm on MMM D, YYYY')}
        {props.approveCommentThree && <div><b>Notes:</b> {props.approveCommentThree}</div>}
      </div>
    </div>
  );
};

export default ApproveFourElement;
